<template>
    <div>
        <component v-bind:is="contentComponent"></component>
    </div>
</template>
<script>
//import { transform } from 'zqyl-module-standalone'
import axiosLC from './lib/request.js'
import { makeUpHtml, vueTemplate, cssStyle} from './lib/html.js'
import { makeUpJs } from './lib/js.js'
import { makeUpCss } from './lib/css.js'
import main from './lib/main.js'

function fetchJson(params){
    if(!params.pageId || isNaN(params.pageId)){
        this.$message.warning("请求异常");
        return false;
    }
    if(main.domain.includes(window.location.hostname)){
        if(params.branchId === 'template'){
            return axiosLC.get(`/zqyl-lowcode-api/template/page/info?templatePageId=${params.pageId}`)
        }else{
            return axiosLC.get(`/zqyl-lowcode-api/page/info?pageId=${params.pageId}&branchId=${params.branchId}`)
        }
    }else{
        return axiosLC.get(`${main.baseUrl()}/lowcode/${params.pageId}/application.json`)
    }
}


function generate(source,dataSource){
    const scriptString = makeUpJs(source,dataSource)
    const html = vueTemplate(makeUpHtml(source));
    const script = eval('('+scriptString+')');
    const css = cssStyle(makeUpCss(source));
    //console.log(html);
    //console.log(scriptString);
    return {
        html,
        script:script,
        css,
        scriptString
    };
}
export default {
    data(){
        return {
            params:null
        }
    },
    watch:{
        "$route.path":{
            handler(){
                this.params = this.$route.params;
            },
            immediate:true
        }
    },
    computed: {
        contentComponent(){
            let params = this.params;
            return function(resolve,reject){
                try {
                    fetchJson(params).then(res=>{
                        let data = null;
                        if(main.domain.includes(window.location.hostname)){
                            if(params.branchId === 'template'){
                                data = JSON.parse(res.data.data.jsonContent)
                            }else{
                                data = JSON.parse(res.data.data) 
                            }
                        }else{
                            data = res.data
                        }
                        //用于判断限制域名中使用代理
                        window.LOWCODE['power'] = main.domain;
                        
                        const drawingList = JSON.parse(data.drawingList);
                        const dataSource = JSON.parse(data.source);
                        main.initDataSource(dataSource);
                        const template = generate(drawingList,dataSource);
                        //全局注册对象
                        window.LOWCODE['debug'] = {
                            js:template.scriptString,
                            html:template.html
                        }
                        if(data.global){
                            let global = JSON.parse(data.global);
                            window.LOWCODE['axios'] = {
                                GET: global.axios.app ? window.LOWCODE["app"][global.axios.app.get] : axiosLC,
                                POST: global.axios.app ? window.LOWCODE["app"][global.axios.app.post] : axiosLC
                            }
                            document.body.style.backgroundColor = global.background;
                        }
                        resolve({
                            ...template.script,
                            template:`${template.html}`,
                        })
                    })
                } catch (error) {
                    console.log("error",error);
                    reject(error);
                }
            }
        },
    }
}
</script>
<style lang="less">
.low-tabs-title{
    > .el-tabs__header{
        background: #fff;
        padding: 0 40px;
    }
}
</style>